import withNavigationTheme from '../../hooks/withNavigationTheme';
import TopNavigationDrawer from './TopNavigationDrawer';

export default withNavigationTheme(TopNavigationDrawer);
